import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { CRITERIA_GROUP, MAX_INDICATOR } from '../../../common/constant'
import { getCurrentTime } from '../../../common/helper'
import { changeAlertPopup } from '../../../common/store/slice'
import {
  changeCriteria,
  selectCriteria,
  selectSelectedIndicatorCount,
} from '../../store/slice'
import classes from './index.module.scss'

export const Indicator = ({ financialType, indicator }) => {
  const dispatch = useDispatch()

  const isSelected = useSelector(
    selectCriteria(
      [CRITERIA_GROUP.FINANCIALS, indicator.screeningIndicatorId],
      (data) => !!data,
    ),
  )
  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)

  const [backgroundColor, setBackgroundColor] = useState('transparent')

  const onMouseEnter = () => {
    setBackgroundColor('#C8E3FF')
  }

  const onMouseLeave = () => {
    setBackgroundColor('transparent')
  }

  const onClickItem = () => {
    if (isSelected) return
    if (selectedIndicatorCount >= MAX_INDICATOR) {
      dispatch(
        changeAlertPopup({
          isShow: true,
          title: 'screening.WARNING',
          message: 'screening.MAX_INDICATOR_MESS',
          translateProps: { max: MAX_INDICATOR, dangerousHTML: true },
        }),
      )
      return
    }

    dispatch(
      changeCriteria({
        path: [CRITERIA_GROUP.FINANCIALS, indicator.screeningIndicatorId],
        data: {
          screeningIndicatorId: indicator.screeningIndicatorId,
          indicatorType: indicator.indicatorType,
          createdAt: getCurrentTime(),
        },
      }),
    )
  }

  return (
    <Element
      className={classes.indicator}
      style={{ backgroundColor }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClickItem}
    >
      <Element
        elementName="span"
        style={{ color: isSelected ? '#0553A5' : '#191D25' }}
      >
        {indicator.screeningIndicatorName}
      </Element>
      {isSelected && (
        <Icon className="icon-tick" style={{ color: '#2C73E8' }} />
      )}
    </Element>
  )
}
